import React from "react";
import { Mail, Phone, Headphones } from "lucide-react";
import CubeImg from "../img/cubecon.png"; // Replace with actual image path

const ContactSection = () => {
  return (
    <div
      className="w-full py-20 px-6 md:px-24 text-white overflow-hidden z-50"
      style={{
        background:
          "radial-gradient(93.96% 223.34% at -10.76% 33.62%, #07031C 0%, #241D49 30.52%, #07031C 64.32%)",
      }}
    >
      {/* Decorative Image Bottom Right */}
  <img
  src={CubeImg}
  alt="decor"
  className="absolute bottom-[-120px] right-0 w-[180px] md:w-[260px] opacity-90 pointer-events-none"
/>





      {/* Header */}
      <div className=" text-left mb-12 z-10 ">
        <h2 className="text-3xl md:text-4xl font-bold font-lato leading-snug">
          Get in Touch With Us; <br />
          <span className="text-[#F2C493]">Capital Nest We’re Here To Help</span>
        </h2>
        <p className="text-sm md:text-base text-gray-200 mt-4 max-w-2xl">
          Reach out for any inquiries, support, or feedback – we’re just a message away!<br />
          You can contact us via email or the 24/7 support channel, both links can be found below
        </p>
      </div>

      {/* Cards */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-10 z-10 relative">
        {/* Email Card */}
        <div className="rounded-xl border  md:w-[230px] border-white border-opacity-20 p-6 text-center hover:border-[#F2C493] transition-all duration-300">
          <div className="flex  justify-start mb-4">
            <Mail className="text-[#F2C493] " size={32} />
          </div>
          <h3 className="text-lg font-semibold mb-1 text-left mt-8">Contact Support</h3>
          <p className="text-sm mb-2 text-gray-300 text-left">We're here to help</p>
          <p className="text-[#D4F5F9] font-medium  text-[14px] text-left mt-12">support@hqcapitalnest.com</p>
        </div>

        {/* Phone Card */}
        <div className="rounded-xl border  md:w-[230px]  border-white border-opacity-20 p-6 text-center hover:border-[#F2C493] transition-all duration-300">
          <div className="flex justify-start mb-4">
            <Phone className="text-[#F2C493]" size={32} />
          </div>
          <h3 className="text-lg font-semibold mb-1eft text-left mt-8">Call Us</h3>
          <p className="text-sm mb-2 text-gray-300 text-left">Mon–Friday 8am–4pm</p>
          <p className="text-[#D4F5F9] font-medium mt-12 text-left">+1558-3345-8876</p>
        </div>

        {/* Chat Card */}
        <div className="rounded-xl border  md:w-[230px] border-white border-opacity-20 p-6 text-center hover:border-[#F2C493] transition-all duration-300">
          <div className="flex justify-start mb-4">
            <Headphones className="text-[#F2C493]" size={32} />
          </div>
          <h3 className="text-lg font-semibold mb-1 text-left mt-8">Live Chat</h3>
          <p className="text-sm mb-2 text-gray-300 text-left">24/7</p>
          <p className="text-[#D4F5F9] font-medium cursor-pointer hover:underline mt-12 text-left">Call →</p>
        </div>
      </div>
    </div>
  );
};

export default ContactSection;
